import axios from 'axios'

function getMessage(errCode, config) {
  return typeof config === 'function' ? config()[errCode] : config[errCode]
}


const handler = config => ({
  async get({ commit }, url, requestConfig) {
    commit('showLoading')
    let response = null

    console.log("get url:", url)
    try {
      if (process.env.NODE_ENV == "development") {
        url = `http://localhost:3000${url}`
      }
      
      response = await axios.get(url, requestConfig)
    } catch (err) {
      console.log("err", err)
      response = {
        status: err.message.split('code ')[1],
      }
    }

    commit('hideLoading')
    const message = getMessage(response.status, config)

    return {
      response: response.data || null,
      message,
    }
  },

  async authGet({ commit, getters }, url, requestConfig) {
    const token = getters ? getters.getToken : null

    const request = {
      ...requestConfig,
      headers: { Authorization: token },
    }

    const result = await this.get({ commit }, url, request)
    return result
  },

  async post({ commit }, url, data, requestConfig) {
    commit('showLoading')
    let response = null

    try {
      console.log("post", url)
      if (process.env.NODE_ENV == "development") {
        url = `http://localhost:3000${url}`
      }

      response = await axios.post(url, data, requestConfig)
    } catch (err) {
      response = {
        status: err.message.split('code ')[1],
      }
    }

    commit('hideLoading')
    const message = getMessage(response.status, config)

    return {
      response: response.data || null,
      message,
    }
  },

  async authPost({ commit, getters }, url, data, requestConfig) {
    const token = getters ? getters.getToken : null

    const request = {
      ...requestConfig,
      headers: { Authorization: token },
    }

    const result = this.post({ commit }, url, data, request)
    return result
  },

  async put({ commit }, url, data, requestConfig) {
    commit('showLoading')
    let response = null

    try {
      console.log("put", url)
      if (process.env.NODE_ENV == "development") {
        url = `http://localhost:3000${url}`
      }

      response = await axios.put(url, data, requestConfig)
    } catch (err) {
      response = {
        status: err.message.split('code ')[1],
      }
    }

    commit('hideLoading')
    const message = getMessage(response.status, config)

    return {
      response: response.data || null,
      message,
    }
  },

  async authPut({ commit, getters }, url, data, requestConfig) {
    const token = getters ? getters.getToken : null

    const request = {
      ...requestConfig,
      headers: { Authorization: token },
    }

    const result = this.put({ commit }, url, data, request)
    return result
  },

  async patch({ commit }, url, data, requestConfig) {
    commit('showLoading')
    let response = null

    try {
      if (process.env.NODE_ENV == "development") {
        url = `http://localhost:3000${url}`
      }

      response = await axios.patch(url, data, requestConfig)
    } catch (err) {
      response = {
        status: err.message.split('code ')[1],
      }
    }

    commit('hideLoading')
    const message = getMessage(response.status, config)

    return {
      response: response.data || null,
      message,
    }
  },

  async authPatch({ commit, getters }, url, data, requestConfig) {
    const token = getters ? getters.getToken : null

    const request = {
      ...requestConfig,
      headers: { Authorization: token },
    }


    console.log("patch", url)
    const result = this.patch({ commit }, url, data, request)
    return result
  },

  async delete({ commit }, url, requestConfig) {
    commit('showLoading')
    let response = null

    try {
      if (process.env.NODE_ENV == "development") {
        url = `http://localhost:3000${url}`
      }

      response = await axios.delete(url, requestConfig)
    } catch (err) {
      response = {
        status: err.message.split('code ')[1],
      }
    }

    commit('hideLoading')
    const message = getMessage(response.status, config)

    return {
      response: response.data || null,
      message,
    }
  },

  async authDelete({ commit, getters }, url, requestConfig) {
    const token = getters ? getters.getToken : null

    const request = {
      ...requestConfig,
      headers: { Authorization: token },
    }

    const result = this.delete({ commit }, url, request)
    return result
  },
})

export default handler




// WEBPACK FOOTER //
// ./src/vuex/handler/handler.js